import React, { useEffect } from "react";
import { useInView } from "framer-motion";
import { useRef } from "react";

export interface OverViewWrapperProps {
  id: string;
  callback: (id: string, type: "inview" | "outview") => void;
}

const OverViewWrapper: React.FunctionComponent<
  React.PropsWithChildren<OverViewWrapperProps>
> = ({ id, callback, children }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const isInView = useInView(ref, { once: false, amount: 0.5 });

  useEffect(() => {
    if (isInView) {
      callback(id, "inview");
    } else {
      callback(id, "outview");
    }
  }, [isInView]);

  return (
    <div className="[&>div>div]" ref={ref}>
      {children}
    </div>
  );
};
export default OverViewWrapper;
